export default __webpack_public_path__ + "static/media/twitter_plain.9b436a66.svg";